import ApiClient from '@/services/apiClient';

export default class BluetoothConfig {
    remote_id;
    card_mode;
    slide_mode;
    tap_mode;
    remote_mode;
    hand_free_mode;

    constructor() {
      this.remote_id = 0;
      this.card_mode = 'Inactive';
      this.slide_mode = 'Inactive';
      this.tap_mode = 'Inactive';
      this.remote_mode = 'Inactive';
      this.hand_free_mode = 'Inactive';
    }

    static constructFromObject(data, obj) {
      obj = obj || new BluetoothConfig();
      if (data) {
        obj.remote_id = ApiClient.convertToType(data['remote_id'], 'Integer')?? 0;
        obj.card_mode = ApiClient.convertToType(data['card_mode'], 'String')?? 'Inactive';
        obj.slide_mode = ApiClient.convertToType(data['slide_mode'], 'String')?? 'Inactive';
        obj.tap_mode = ApiClient.convertToType(data['tap_mode'], 'String')?? 'Inactive';
        obj.remote_mode = ApiClient.convertToType(data['remote_mode'], 'String')?? 'Inactive';
        obj.hand_free_mode = ApiClient.convertToType(data['hand_free_mode'], 'String')?? 'Inactive';
      }
      return obj;
    }

    toJSON() {
      const json = {
        remote_id: this.remote_id,
      };
      if(this.card_mode != 'Inactive') {
        json.card_mode = this.card_mode;
      }
      if(this.slide_mode != 'Inactive') {
        json.slide_mode = this.slide_mode;
      }
      if(this.tap_mode != 'Inactive') {
        json.tap_mode = this.tap_mode;
      }
      if(this.remote_mode != 'Inactive') {
        json.remote_mode = this.remote_mode;
      }
      if(this.hand_free_mode != 'Inactive') {
        json.hand_free_mode = this.hand_free_mode;
      }
      return json;
    }
}
